










import { Vue, Component } from 'vue-property-decorator';
import FuncionesGlobales from '@/pantallas/FuncionesGlobales/FuncionesGlobales.vue';

@Component({
  components: { FuncionesGlobales },
})
export default class FuncionesGlobalesPantalla extends Vue {}
